<div>
    <h2>Login</h2>
    <form ngFormModel="form">
        <div class="error" *ngIf="serverError">
            <p>{{serverError}}</p>
        </div>
    </form>
    <b2c-content-host [b2cFrameSource]="b2cFrameSource" [b2cFrameHeight]="b2cFrameHeight"></b2c-content-host>
</div>